<div class="prose w-full max-w-none">
  <h1 class="mb-12">Frequently Asked Questions</h1>

  <!-- - How do I create a new account?
Visit our /register page, and use your account information to create a new account. Alternatively if another person at your company has already created an account, they can send you an invitation directly from the Users page, with the Invite a User button.
-->
  <h2 class="mb-4 mt-0">How do I create a new account?</h2>
  <p class="mb-8 ml-4">
    Visit our <a [routerLink]="'/register'">Sign Up</a> page, and use your
    account information to create a new account. Alternatively if another person
    at your company has already created an account, they can send you an
    invitation directly from the Users page, with the Invite a User button.
  </p>

  <!-- - When trying to create an account, I get a "The details provided cannot be verified." error.
When creating a new account all of the information entered must match the information we have on file for your company, and your email must be on file for your account. If your email is not on file with us for your company and you wish to add it, please visit our contact update page here: https://www.accuzip.com/contact/update-contact-info/. If you do not wish to add your email as a contact for your company, you can instead have an existing user for your company send you an invitation from the Users page, using the Invite a User button.
-->
  <h2 class="mb-4 mt-0 border-t border-base-content/50 pt-6">
    When trying to create an account I get an error saying "The details provided
    cannot be verified." What does this mean?
  </h2>
  <p class="mb-8 ml-4">
    When creating a new account all of the information entered must match the
    information we have on file for your company, including your email. If your
    email is not on file with us for your company and you wish to add it, please
    visit our
    <a
      href="https://www.accuzip.com/contact/update-contact-info/"
      target="_blank"
      >Contact Update</a
    >
    page. If you do not wish to add your email as a contact for your company,
    you can instead have an existing user for your company send you an
    invitation from the Users page, using the Invite a User button.
  </p>
</div>
